/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CloseCaptionsIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Close Captions',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M31.5 6h-27A4.5 4.5 0 0 0 0 10.5v15A4.5 4.5 0 0 0 4.5 30h27a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 31.5 6Zm-14.837 7.612a.809.809 0 0 1-.37.715l-.323.2-.459-.183a5.96 5.96 0 0 0-2.342-.376 3.721 3.721 0 0 0-4.02 4 3.817 3.817 0 0 0 4.061 4.042 6.586 6.586 0 0 0 2.279-.308l.311-.102.381.163a.787.787 0 0 1 .361.691v1.812a.935.935 0 0 1-.57.9 9.648 9.648 0 0 1-3.065.416c-4.657 0-7.667-2.961-7.667-7.544 0-4.55 3.2-7.606 7.972-7.606a7.566 7.566 0 0 1 2.922.4.908.908 0 0 1 .531.848Zm13.5 0a.809.809 0 0 1-.37.715l-.323.2-.459-.183a5.96 5.96 0 0 0-2.342-.376 3.721 3.721 0 0 0-4.02 4 3.817 3.817 0 0 0 4.061 4.042 6.586 6.586 0 0 0 2.279-.308l.311-.102.381.163a.787.787 0 0 1 .361.691v1.812a.935.935 0 0 1-.57.9 9.648 9.648 0 0 1-3.065.416c-4.657 0-7.667-2.961-7.667-7.544 0-4.55 3.205-7.606 7.972-7.606a7.566 7.566 0 0 1 2.922.4.908.908 0 0 1 .531.848Z"
    />
  </svg>`;
};
